"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var url = require('url');
var qs = require('querystring');
var _require = require('../../utils'),
  omit = _require.omit,
  isValidURL = _require.isValidURL;
module.exports = {
  authResponse: authResponse,
  erroredResponse: erroredResponse,
  handleAjaxResponse: handleAjaxResponse,
  sanitizeOptions: sanitizeOptions
};
var JSON_REGEXP = /^application\/([\w!#$%&*`\-.^~]*\+)?json$/i;

/**
 * Handle the xhr response for OAuth requests consistently.
 *
 * @param  {Object}   options
 * @param  {Function} done
 * @return {Function}
 */
function handleAjaxResponse(xhr, options) {
  var body = xhr.body;
  var mime = (xhr.headers.get('content-type') || '').split(';')[0];
  if (JSON_REGEXP.test(mime)) {
    return authResponse(options, body);
  }
  return authResponse(options, qs.parse(body));
}
function sanitizeOptions(options) {
  var oauthCallback = options.oauthCallback || '/authentication/oauth.html';
  var REDIRECT_URI = global.location ? url.resolve(global.location.href, oauthCallback) : null;

  // Extend an default options object.
  var opts = _objectSpread({
    redirectUri: REDIRECT_URI
  }, options);

  // Fix up reference to the `scopes` array.
  opts.scope = opts.scope || opts.scopes;
  if (Array.isArray(opts.scope)) {
    opts.scope = opts.scope.join(' ');
  }

  // Remove unused `scopes` property.
  delete opts.scopes;
  if (opts.accessTokenUri && !isValidURL(opts.accessTokenUri)) {
    throw new TypeError('"accessTokenUri" not valid');
  }
  if (opts.authorizationUri && !isValidURL(opts.authorizationUri)) {
    throw new TypeError('"authorizationUri" not valid');
  }
  if (opts.redirectUri && !isValidURL(opts.redirectUri)) {
    throw new TypeError('"redirectUri" not valid');
  }
  return opts;
}

/**
 * Validate an OAuth2 response object.
 *
 * @param {Object}   options
 * @param {Object}   response
 * @param {Function} done
 */
function authResponse(options, response) {
  // Check the response object for errors.
  if (erroredResponse(response)) {
    throw new Error(erroredResponse(response));
  }

  // Filter the response data of known parameters.
  var data = {
    scope: response.scope || options.scope,
    response: omit(response, 'access_token', 'refresh_token', 'token_type', 'expires_in', 'scope', 'state', 'error', 'error_description', 'error_uri'),
    accessToken: response.access_token
  };

  // Omit the response object altogether if no response is available.
  if (!Object.keys(data.response).length) {
    delete data.response;
  }
  if (response.token_type) {
    data.tokenType = response.token_type;
  }
  if (+response.expires_in) {
    data.expires = Date.now() + response.expires_in * 1000;
  }
  if (response.refresh_token) {
    data.refreshToken = response.refresh_token;
  }
  return data;
}

/**
 * Format error response types to regular strings for displaying the clients.
 * Reference: http://tools.ietf.org/html/rfc6749#section-4.1.2.1
 *
 * @type {Object}
 */
var ERROR_RESPONSES = {
  invalid_request: ['The request is missing a required parameter, includes an', 'invalid parameter value, includes a parameter more than', 'once, or is otherwise malformed.'].join(' '),
  invalid_client: ['Client authentication failed (e.g., unknown client, no', 'client authentication included, or unsupported', 'authentication method).'].join(' '),
  invalid_grant: ['The provided authorization grant (e.g., authorization', 'code, resource owner credentials) or refresh token is', 'invalid, expired, revoked, does not match the redirection', 'URI used in the authorization request, or was issued to', 'another client.'].join(' '),
  unauthorized_client: ['The client is not authorized to request an authorization', 'code using this method.'].join(' '),
  unsupported_grant_type: ['The authorization grant type is not supported by the', 'authorization server.'].join(' '),
  access_denied: ['The resource owner or authorization server denied the request.'].join(' '),
  unsupported_response_type: ['The authorization server does not support obtaining', 'an authorization code using this method.'].join(' '),
  invalid_scope: ['The requested scope is invalid, unknown, or malformed.'].join(' '),
  server_error: ['The authorization server encountered an unexpected', 'condition that prevented it from fulfilling the request.', '(This error code is needed because a 500 Internal Server', 'Error HTTP status code cannot be returned to the client', 'via an HTTP redirect.)'].join(' '),
  temporarily_unavailable: ['The authorization server is currently unable to handle', 'the request due to a temporary overloading or maintenance', 'of the server.'].join(' ')
};

/**
 * Return the formatted error string.
 *
 * @param  {Object} data
 * @return {String}
 */
function erroredResponse(data) {
  return ERROR_RESPONSES[data.error] || data.error || data.error_message;
}
//# sourceMappingURL=utils.js.map